module.exports = __webpack_public_path__ + "img/collection-weddingRingsFacettedConnections.79bab7b.webp";